import { render, staticRenderFns } from "./AccountDepositView.vue?vue&type=template&id=ba051e66&"
import script from "./AccountDepositView.vue?vue&type=script&lang=js&"
export * from "./AccountDepositView.vue?vue&type=script&lang=js&"
import style0 from "./AccountDepositView.vue?vue&type=style&index=0&id=ba051e66&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports